<template>
  <div>
    <!-- page meta -->
    <Head>
      <title>Platforma | About</title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
      <meta
        name="description"
        content="We are Platforma. The Why Behind the Powerhouse."
      />
    </Head>
  </div>
  <!-- content start -->

  <div class="about-hero bg-center bg-no-repeat pt-[150px] pb-[300px]">
    <!-- ===================== HERO SECTION ===================== -->

    <section id="section1" class="mx-auto my-auto lg:flex lg:w-[1140px]">
      <div
        class="mt-0 bg-transparent px-[25px] xl:px-0 text-center h-[150px] mx-auto"
      >
        <h1
          class="top-full mt-[50px] px-0 text-[35px] font-extrabold tracking-normal text-[#fff] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[70px]"
        >
          We are Platforma.
        </h1>

        <p
          class="mt-[15px] mb-[25px] text-[15px] font-medium text-white opacity-50 lg:text-lg"
        >
          A great workplace combines exceptional people with challenging
          problems.
        </p>
      </div>

      <!-- <div class="mb-[30px] w-[650px]  mt-[30px] px-[25px] lg:mt-0 lg:px-0">
        <img
          loading="lazy"
          class="w-[650px]"
          :src="$filters.media_path('/images/clickup-people 1.png')"
          alt="Provide a private member portal with video calls."
        />
      </div> -->
    </section>
  </div>

  <!-- ===================== MISSION SECTION===================== -->
  <section
    class="mt-[50px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[50px] lg:flex lg:h-[500px] xl:px-0"
  >
    <div class="z-20 mx-auto mt-12 justify-center gap-1 py-0 lg:flex">
      <div class="mt-0 text-center lg:max-w-[500px] lg:text-left">
        <div id="text_mission" class="text-xs font-extrabold text-[#2D8CFF]">
          MISSION
        </div>

        <h2
          class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Our Mission.
        </h2>

        <hr
          class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#2D8CFF] lg:ml-0"
        />

        <p
          class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
        >
          While we absolutely love marketing software, we believe content
          distribution, in general, is broken. There's just too many tools to
          keep track of, too much censorship and not enough money flowing to
          where it should. There has to be a better way to monetize content -
          that's why we created Platforma, first an internal tool, now as a way
          to fulfill our vision of giving power back to the creator.<br />
          <br />
          Eventually, our goal is to have all members live in Platforma -
          thereby giving the internet back to the people. Protect and Monetize
          Your Content. We're just getting started, and are so grateful for all
          of the 10,000+ entrepreneurs that are in this together with our team.
        </p>
      </div>

      <div class="z-30 mt-[25px] xl:mt-0">
        <img
          loading="lazy"
          class="lg:w-[675px]"
          :src="
            $filters.media_path(
              '/images/platforma-membership-sites-mission-hero.svg'
            )
          "
          alt="Host all your company training courses in one place."
        />
      </div>
    </div>
  </section>

  <!-- ===================== MOTTO SECTION ===================== -->

  <section
    class="motto-bg mt-[60px] flex h-[400px] w-full bg-cover bg-no-repeat lg:mt-[250px]"
  >
    <div class="mx-auto my-auto flex lg:w-[1140px]">
      <div>
        <img
          :src="$filters.media_path('/images/motto-quotes.svg')"
          alt=""
          loading="lazy"
        />
      </div>

      <div
        id="text_mission"
        class="text-xs font-extrabold text-[#FFC800] lg:mt-[50px]"
      >
        OUR MOTTO

        <h2
          class="top-full mt-[20px] px-0 text-[35px] font-bold leading-normal text-white sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Protect and Monetize your content.
        </h2>
      </div>
    </div>
  </section>

  <!-- OUR TEAM -->

  <section class="mx-[25px] mt-[145px] text-center">
    <div class="text-center">
      <div
        id="text_team"
        class="text-center text-xs font-bold tracking-wide text-[#2D8CFF]"
      >
        OUR TEAM
      </div>

      <h2
        class="px-auto top-full mt-[20px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
      >
        Meet the team!
      </h2>

      <p
        class="mt-[20px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-full"
      >
        Platformers are highly passionate, energetic, and unique people that
        align in the mission of saving people time and making the world more
        productive. Join us.
      </p>
    </div>

    <img
      :src="
        $filters.media_path(
          '/images/platforma_map_secure_data_guard_against_censorship.png'
        )
      "
      alt=""
      class="mx-auto mt-10 w-[1144px]"
      loading="lazy"
    />
  </section>

  <!-- OUR PROGRESS -->

  <section class="text-center pb-[200px]">
    <div
      id="text_progress"
      class="mx-auto mt-[100px] max-w-[1140px] text-xs font-extrabold text-[#2D8CFF]"
    >
      OUR PROGRESS

      <h2
        class="top-full mt-[20px] mb-[50px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
      >
        Milestones
      </h2>
    </div>

    <img
      :src="$filters.media_path('/images/about-us-milestones.svg')"
      alt=""
      class="mx-auto w-[1610px]"
      loading="lazy"
    />

    <hr class="-mt-[15px] h-1 w-full bg-gray-100" />

    <button
      class="mt-[90px] h-[50px] w-[148px] rounded-[4px] bg-[#2d8bff] text-[14px] font-bold text-white drop-shadow-[0px_10px_25px_#64A7F9] transition ease-in hover:bg-[#0f61c5] active:bg-[#054ca3] dark:border-none"
    >
      Join Our Team
    </button>
  </section>
</template>

<!-- CONTENT END -->

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';
import ButtonComponent from '@shared/Components/ButtonComponent.vue';
import Axios from 'axios';
import EmailCaptureHeaderWidget from '../Components/EmailCaptureHeader.vue';

export default {
  layout: DefaultLayout,
  components: {
    ButtonComponent,
    EmailCaptureHeaderWidget
  },

  computed: {
    backgroundImageStyleMain() {
      const imagePath = this.$filters.media_path(
        'images/platforma-header-background-eclipse.svg'
      );
      return {
        '--before-background-image': `url(${imagePath})`
      };
    }
  }
};
</script>

<style scoped>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 1000px;
  width: 1700px;
  display: block;
  z-index: 0;
  transform: translateY(-42%) translateX(58%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
}

.about-hero {
  background-image: url(../media/images/about-us-bg-1.svg);
  /* background-size: contain; */
}
.motto-bg {
  background-image: url(../media/images/motto-bg.svg);
  /* background-size: contain; */
}
</style>
